<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>知识库</el-breadcrumb-item>
      <el-breadcrumb-item>设备知识库</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="60px"
          inline
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="关键字">
            <el-input
              v-model="filter.keyword"
              placeholder="问题描述"
              @keyup.enter.native="requestSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="requestSearch"
              >筛选</el-button
            >
            <el-button size="small" @click="requestSearch('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel mt-20">
      <el-table :data="list" v-loading="loading" stripe style="width: 100%">
        <el-table-column label="提问人信息">
          <template slot-scope="scope">
            <div>{{ scope.row.customer_user.name }}</div>
            <div>{{ scope.row.customer.name }}</div>
            <div>
              {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="问题描述"
          prop="title"
          min-width="200"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column align="left" label="回复内容">
          <template slot-scope="scope">
            <div>{{ scope.row.answer.content || '-' }}</div>
            <div class="text-gray" v-if="scope.row.answer.id">
              {{
                $time(scope.row.answer.created_at).format('YYYY-MM-DD HH:mm')
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <status-tag
              :type="scope.row.answer.id ? 'success' : 'gray'"
              :name="scope.row.answer.id ? '已回复' : '待回复'"
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-button
              class="ml-5"
              type="primary"
              plain
              size="mini"
              @click="handleAnswer(scope.$index, scope.row)"
              v-permission="Auth.wikiCommentNew"
              v-if="!scope.row.answer.id"
              >回复</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <ModelFormer
      :model="model"
      :show.sync="itemFormerVisible"
      @created="createdCallback"
    ></ModelFormer>
  </div>
</template>

<script>
import { wikiCommentList } from '@/service/getData'
import ModelFormer from './former'

export default {
  components: {
    ModelFormer,
  },
  data() {
    return {
      loading: false,
      model: {
        question: {},
      },
      itemFormerVisible: false,
      editIndex: 0,
      list: [],
      total: 0,
      filter: {
        size: 20,
        page: 1,
        status: 0,
        keyword: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let params = this.clone(this.filter)
      params.page -= 1

      let res = await wikiCommentList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.loading = false
      }
    },
    handlePageChange(e) {
      this.filter.page = e
      this.getData()
    },
    requestSearch(reset = '') {
      this.filter.page = 1
      if (reset == 'reset') {
        this.filter.status = 0
        this.filter.keyword = ''
      }
      this.getData()
    },
    createdCallback(data) {
      this.getData()
    },
    handleAnswer(index, item) {
      this.itemFormerVisible = true
      this.model = {
        question: item,
        father_id: item.id,
        content: '',
      }
    },
  },
}
</script>